import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { PRESETS_PERIODO_SEM_ONTEM_E_HOJE } from '../../shared/utils/periodo.utils';
import { TransferenciaService } from '../../services/movimento/transferencia.service';
import { ContaService } from '../../services/conta/conta.service';
import { CotacaoGuardService } from '../../services/cotacao/cotacao-guard.service';
import { CotacaoService } from '../../services/cotacao/cotacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ConfirmationService, SortEvent } from 'primeng/api';
import { TipoTransacao } from '../../enums/TipoTransacao.enum';
import { Moeda } from '../../enums/moeda.enum';
import { TransferenciaDTO } from '../../models/gerenciar-contas/transferencia.model';
import { ContaDTO } from '../../models/gerenciar-contas/conta.model';
import { debounceTime, distinctUntilChanged, firstValueFrom, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from '../../models/shared/table-column.model';
import { PeriodoFiltro } from '../../models/dashboard/periodo-filtro.model';
import { Calendar } from 'primeng/calendar';
import { EmpresaConfigService } from '../../services/configuracoes/empresa.service';
import { EmpresaConfigDTO } from '../../models/configuracoes/empresa.model';
import { moedasCompativeis, podeConverterEntre } from '../../utils/moeda-pareamento.util';
import { toLocalISOString } from '../../shared/utils/date-utils';

@Component({
  selector: 'app-nova-transferencia',
  templateUrl: './nova-transferencia.component.html',
  styleUrls: ['./nova-transferencia.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class NovaTransferenciaComponent implements OnInit, OnDestroy, AfterViewInit {
  // Referencia ao input de valor convertido para atualizar via calcularValorConvertido()
  @ViewChild('valorConvertidoInput') valorConvertidoInputRef?: ElementRef<HTMLInputElement>;
  @ViewChild('calendario') calendario!: Calendar;

  // Opcoes do filtro de periodo (sem "Ontem e hoje")
  readonly opcoesPeriodo = PRESETS_PERIODO_SEM_ONTEM_E_HOJE;

  // Controle de abas (padrao nova-despesa)
  activeTabIndex: number = 1;

  // String formatada do campo de valor para exibicao correta ao editar
  montanteStr = '';

  // Label dinamico do botao "Outros" (mostra a data quando selecionada via calendario)
  outrosLabel = '';

  // Sidebar de filtros avancados
  sidebarFiltrosVisible = false;

  // Filtro por moeda (clique nos cards de totais)
  filtroMoedaSelecionada: string | null = null;

  // Loading dos totais
  loadingTotais: boolean = false;

  // Controle de validacao visual
  isFormSubmitted = false;
  submitting = false;

  // Objetos de traducao (seguindo padrao nova-receita)
  texts: any = {};
  labels: any = {};
  placeholders: any = {};
  botoes: any = {};
  tooltips: any = {};

  // Wave dialog de exclusao
  deleteDialogVisible = false;
  deleteItemId: number | null = null;

  // Dialog de confirmacao de cotacao (validacao de tolerancia)
  cotacaoDialogVisible = false;

  private langChangeSub!: Subscription;

  form: TransferenciaDTO = this.createEmptyForm();
  transferencias: TransferenciaDTO[] = [];
  transferenciasOriginal: TransferenciaDTO[] = [];
  contasOptions: { label: string; value: number; moeda: string; flagUrl: string; tipoConta: string }[] = [];
  dataSelecionada: string = 'hoje';
  searchTerm: string = '';
  contasCarregadas: ContaDTO[] | null = null;
  movimento?: any;
  cotacao_id: number = 0;
  cotUSD_PYG: number | undefined;
  cotUSD_BRL: number | undefined;
  cotBRL_PYG: number | undefined;
  // Cotacao ARS<->PYG (pesoGuarani). Spec 08: usado nos calculos PESO<->GUARANI
  // (replicando o padrao BRL<->PYG). Pares ARS<->DOLAR e ARS<->REAL nao existem
  // (matriz MOEDAS_COMPATIVEIS bloqueia; filtro de destino aplica antes).
  cotPesoGuarani: number | undefined;
  rows: number = 10;
  loading: boolean = true;
  totalRecords: number = 0;
  first: number = 0;
  // Ordenacao server-side (padrao UsuarioComponent)
  lastfield: string = 'emissao';
  lastSort: string = 'asc';
  pageSizeOptions = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];

  // Filtros dedicados (padrao nova-despesa)
  filtroObservacao: string = '';
  filtroDataInicio: Date | null = null;
  filtroDataFim: Date | null = null;
  filtroContaId: number | null = null;
  filtroMoeda: string | null = null;
  // Texto exibido no botao do periodo-filtro
  periodoTransferenciaTexto: string = '';
  filtrosAtivos: boolean = false;
  contasFiltroOptions: { label: string; value: number | null; flagUrl: string }[] = [];

  // Empresa (para auto-selecao de conta)
  empresa: EmpresaConfigDTO | null = null;
  /** Flag para evitar reload duplicado na auto-selecao de conta */
  private _initialLoadDone = false;
  /** Flags de prontidao do bootstrap (coordenam o PRIMEIRO loadTransferencias/loadTotais
   *  para que ele dispare UMA so vez, depois que empresa e contas estejam carregadas.
   *  Isto evita chamadas duplicadas a buscar-transferencia e total-transferencia na carga
   *  inicial (a auto-selecao de conta DINHEIRO depende de empresa E contas; sem empresa
   *  o filtro de conta nao e aplicado no primeiro load). */
  private _empresaReady = false;
  private _contasReady = false;
  /** Impede re-entrada no handler (ngModelChange) do dropdown de conta enquanto o
   *  bootstrap esta setando a conta programaticamente via autoSelecionarContaDinheiro. */
  private _settingContaProgramatic = false;

  // Totais por moeda
  totalGuarani: number = 0;
  totalDolar: number = 0;
  totalReal: number = 0;
  totalPeso: number = 0;

  /**
   * Conjunto de moedas permitidas para a empresa logada, baseado na
   * matriz de pareamento (moedasCompativeis). Usado para filtrar quais
   * cards de Total exibir.
   *
   * Fallback: enquanto a empresa nao carregou, retorna o conjunto completo
   * (todas as 4 moedas) para evitar placeholder vazio. O filtro fica
   * estavel apos a primeira resposta de getSessao().
   */
  get moedasPermitidas(): Set<string> {
    const moedaEmp = this.empresa?.moeda
      ? this.asEnumString(this.empresa.moeda)
      : null;
    if (!moedaEmp) return new Set(['GUARANI', 'DOLAR', 'REAL', 'PESO']);
    return new Set(moedasCompativeis(moedaEmp as any));
  }

  /** Retorna true quando a conta selecionada no filtro é uma conta bancária (tipoConta === 'BANCO'). */
  get contaBancariaAtiva(): boolean {
    if (this.filtroContaId == null) return false;
    const conta = this.contasCarregadas?.find(c => c.id === this.filtroContaId);
    const tipo = (conta as any)?.tipoConta;
    const tipoStr = typeof tipo === 'object' ? tipo?.enum : tipo;
    return tipoStr === 'BANCO';
  }

  /** Retorna o enum da moeda da conta selecionada (GUARANI, DOLAR, REAL) ou null. */
  get moedaContaSelecionada(): string | null {
    if (this.filtroContaId == null) return null;
    const conta = this.contasCarregadas?.find(c => c.id === this.filtroContaId);
    return (conta as any)?.moeda?.enum || null;
  }

  /**
   * Lista de contas de destino filtradas pela matriz de moedas compativeis
   * a partir da moeda da conta origem selecionada. Espelha a logica do
   * backend (MoedaPareamentoValidator) para evitar 422 pos-submit.
   *
   * - Sem origem selecionada: retorna todas (UX: usuario ainda nao decidiu).
   * - Com origem: filtra `contasOptions` por `podeConverterEntre(origem, destino)`
   *   e exclui a propria conta origem (destino != origem).
   */
  get contasDestinoFiltradasOptions(): { label: string; value: number; moeda: string; flagUrl: string; tipoConta: string }[] {
    if (this.form.conta_id == null) {
      return this.contasOptions;
    }
    const contaOrigem = this.contasCarregadas?.find(c => c.id === this.form.conta_id);
    const moedaOrigemRaw = (contaOrigem as any)?.moeda;
    const moedaOrigem: string | null = moedaOrigemRaw?.enum || (typeof moedaOrigemRaw === 'string' ? moedaOrigemRaw : null);
    if (!moedaOrigem) {
      return this.contasOptions.filter(opt => opt.value !== this.form.conta_id);
    }
    return this.contasOptions.filter(opt =>
      opt.value !== this.form.conta_id &&
      podeConverterEntre(moedaOrigem, opt.moeda),
    );
  }


  // Cotacao calculada
  cotacaoCalculada: number = 0;

  // Configuracao de colunas visiveis (padrao pessoas-table)
  readonly STORAGE_KEY = 'nova-transferencia-visible-columns';

  columns: TableColumn[] = [
    { key: 'id', labelKey: 'nova-transferencia.labels.id', visible: true, fixed: true, defaultVisible: true },
    { key: 'emissao', labelKey: 'nova-transferencia.labels.data_emissao', visible: true, fixed: false, defaultVisible: true },
    { key: 'observacao', labelKey: 'nova-transferencia.labels.observacao', visible: true, fixed: false, defaultVisible: true },
    { key: 'contaOrigem', labelKey: 'nova-transferencia.labels.conta_origem', visible: true, fixed: false, defaultVisible: true },
    { key: 'contaDestino', labelKey: 'nova-transferencia.labels.conta_destino', visible: true, fixed: false, defaultVisible: true },
    { key: 'valorConvertido', labelKey: 'nova-transferencia.labels.valor_convertido', visible: false, fixed: false, defaultVisible: false },
    { key: 'valor', labelKey: 'nova-transferencia.labels.valor', visible: true, fixed: false, defaultVisible: true },
    { key: 'acoes', labelKey: 'nova-transferencia.labels.acoes', visible: true, fixed: true, defaultVisible: true },
  ];

  private search$ = new Subject<string>();

  constructor(
    private transferenciaService: TransferenciaService,
    private contaService: ContaService,
    private cotacaoService: CotacaoService,
    private cotacaoGuard: CotacaoGuardService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private empresaService: EmpresaConfigService,
  ) { }

  ngAfterViewInit(): void {
    // Desabilitar tabindex do input do calendario para evitar foco acidental
    if (this.calendario?.inputfieldViewChild?.nativeElement) {
      this.calendario.inputfieldViewChild.nativeElement.setAttribute('tabindex', '-1');
    }
  }

  ngOnInit() {
    this.loadContas();
    this.lerFiltrosDashboard();
    this.findEmpresa();
    this.loadCotacoes();
    this.setupSearchDebounce();
    this.definirDataHoje();
    this.loadTranslations();
    this.loadColumnPreferences();

    // Abrir aba de cadastro se vier do menu de atalhos com aba=cadastro
    if (this.route.snapshot.queryParams['aba'] === 'cadastro') {
      this.activeTabIndex = 0;
    }

    // Se veio editId via queryParams (navegacao da lista de movimentos), carregar transferencia para edicao
    const editId = this.route.snapshot.queryParams['editId'];
    if (editId) {
      this.carregarTransferenciaParaEdicao(+editId);
    }

    // Atualiza traducoes quando idioma muda
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.buildContasFiltroOptions();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
    this.search$.complete();
  }

  /** Lê filtros passados pelo dashboard via queryParams e os aplica automaticamente.
   *  Quando não há parâmetros, inicializa com o mês atual como período padrão. */
  private lerFiltrosDashboard(): void {
    const params = this.route.snapshot.queryParams;
    const dataInicial = params['dataInicial'];
    const dataFinal = params['dataFinal'];
    const contaId = params['contaId'];

    if (dataInicial) {
      this.filtroDataInicio = this.parsarDataDashboard(dataInicial);
    }
    if (dataFinal) {
      this.filtroDataFim = this.parsarDataDashboard(dataFinal);
    }
    if (contaId) {
      const id = parseInt(contaId, 10);
      if (!isNaN(id)) {
        this.filtroContaId = id;
      }
    }

    if (this.filtroDataInicio || this.filtroDataFim || this.filtroContaId !== null) {
      this.filtrosAtivos = true;
    } else {
      // Sem parâmetros do dashboard: aplicar período padrão "Mostrar todos"
      // (showAll), equivalente ao valorPadrao='showAll' do app-periodo-filtro.
      // Intervalo fixo 01/01/2000 00:00 -> 31/12/3000 23:59 (alinhado ao mobile).
      this.filtroDataInicio = new Date(2000, 0, 1, 0, 0, 0);
      this.filtroDataFim = new Date(3000, 11, 31, 23, 59, 59);
      this.filtrosAtivos = true;
    }

    // Nao dispara loadTransferencias + loadTotais aqui:
    // o PRIMEIRO load e coordenado em dispararCargaInicialSePronto(),
    // depois que empresa e contas estiverem prontas e a auto-selecao de
    // conta DINHEIRO tiver sido aplicada (evita chamadas duplicadas).
  }

  private loadTranslations(): void {
    const isEdicao = !!this.form.id;
    const isListaAtiva = this.activeTabIndex === 1;

    this.texts = {
      titulo: this.translate.instant(
        isListaAtiva ? 'nova-transferencia.texts.titulo_nova' : isEdicao ? 'nova-transferencia.texts.titulo_editar' : 'nova-transferencia.texts.titulo_nova'
      ),
      subtitulo: this.translate.instant(
        isListaAtiva
          ? 'nova-transferencia.texts.subtitulo_lista'
          : isEdicao
          ? 'nova-transferencia.texts.subtitulo_editar'
          : 'nova-transferencia.texts.subtitulo_nova'
      ),
      dados_da_transferencia: this.translate.instant('nova-transferencia.texts.dados_da_transferencia'),
      valor_e_data: this.translate.instant('nova-transferencia.texts.valor_e_data'),
      lista_de_transferencias: this.translate.instant('nova-transferencia.texts.lista_de_transferencias'),
      nenhuma_transferencia: this.translate.instant('nova-transferencia.texts.nenhuma_transferencia'),
      ajuste_filtros: this.translate.instant('nova-transferencia.texts.ajuste_filtros'),
      carregando: this.translate.instant('nova-transferencia.texts.carregando'),
      cotacao_do_dia: this.translate.instant('nova-transferencia.texts.cotacao_do_dia'),
      confirmacao: this.translate.instant('common.confirmacao'),
      confirmar_exclusao: this.translate.instant('nova-transferencia.mensagens.confirmar_exclusao'),
      total_guarani: this.translate.instant('nova-transferencia.texts.total_guarani'),
      total_dolar: this.translate.instant('nova-transferencia.texts.total_dolar'),
      total_real: this.translate.instant('nova-transferencia.texts.total_real'),
      total_peso: this.translate.instant('nova-transferencia.texts.total_peso'),
      confirmar_cotacao: this.translate.instant('nova-transferencia.texts.confirmar_cotacao'),
      cotacao_fora_tolerancia: this.translate.instant('nova-transferencia.texts.cotacao_fora_tolerancia'),
      cotacao_calculada_label: this.translate.instant('nova-transferencia.texts.cotacao_calculada_label'),
      cotacao_do_dia_label: this.translate.instant('nova-transferencia.texts.cotacao_do_dia_label'),
      valor_label: this.translate.instant('nova-transferencia.texts.valor_label'),
      valor_convertido_label: this.translate.instant('nova-transferencia.texts.valor_convertido_label'),
      todas_contas: this.translate.instant('nova-transferencia.texts.todas_contas'),
      totais_transferencias: this.translate.instant('nova-transferencia.texts.totais_transferencias'),
      todas_moedas: this.translate.instant('nova-transferencia.texts.todas_moedas'),
      filtros_avancados: this.translate.instant('nova-transferencia.texts.filtros_avancados'),
      filtros_avancados_subtitulo: this.translate.instant('nova-transferencia.texts.filtros_avancados_subtitulo'),
      aba_cadastro: this.translate.instant('nova-transferencia.texts.aba_cadastro'),
      aba_lista: this.translate.instant('nova-transferencia.texts.aba_lista'),
      nova_transferencia: this.translate.instant('nova-transferencia.texts.nova_transferencia')
    };

    this.labels = {
      descricao: this.translate.instant('nova-transferencia.labels.descricao'),
      conta_origem: this.translate.instant('nova-transferencia.labels.conta_origem'),
      conta_destino: this.translate.instant('nova-transferencia.labels.conta_destino'),
      valor: this.translate.instant('nova-transferencia.labels.valor'),
      valor_convertido: this.translate.instant('nova-transferencia.labels.valor_convertido'),
      cotacao_de_transferencia: this.translate.instant('nova-transferencia.labels.cotacao_de_transferencia'),
      cotacao_calculada: this.translate.instant('nova-transferencia.labels.cotacao_calculada'),
      data: this.translate.instant('nova-transferencia.labels.data'),
      hoje: this.translate.instant('nova-transferencia.labels.hoje'),
      ontem: this.translate.instant('nova-transferencia.labels.ontem'),
      outros: this.translate.instant('nova-transferencia.labels.outros'),
      id: this.translate.instant('nova-transferencia.labels.id'),
      data_emissao: this.translate.instant('nova-transferencia.labels.data_emissao'),
      observacao: this.translate.instant('nova-transferencia.labels.observacao'),
      acoes: this.translate.instant('nova-transferencia.labels.acoes'),
      itens_por_pagina: this.translate.instant('nova-transferencia.labels.itens_por_pagina'),
      filtro_observacao: this.translate.instant('nova-transferencia.labels.filtro_observacao'),
      filtro_periodo: this.translate.instant('nova-transferencia.labels.filtro_periodo'),
      filtro_conta: this.translate.instant('nova-transferencia.labels.filtro_conta'),
      filtro_moeda: this.translate.instant('nova-transferencia.labels.filtro_moeda')
    };

    // Atualizar label do botao "Outros" conforme estado atual
    if (this.dataSelecionada === 'outros' && this.form.emissao) {
      this.outrosLabel = this.formatarDataParaExibicao(this.form.emissao);
    } else {
      this.outrosLabel = this.labels.outros;
    }

    this.placeholders = {
      descricao: this.translate.instant('nova-transferencia.placeholders.descricao'),
      selecionar: this.translate.instant('nova-transferencia.placeholders.selecionar'),
      buscar: this.translate.instant('nova-transferencia.placeholders.buscar'),
      valor: this.translate.instant('nova-transferencia.placeholders.valor'),
      filtro_observacao: this.translate.instant('nova-transferencia.placeholders.filtro_observacao')
    };

    this.botoes = {
      salvar: this.translate.instant('nova-transferencia.botoes.salvar'),
      atualizar: this.translate.instant('nova-transferencia.botoes.atualizar'),
      limpar: this.translate.instant('nova-transferencia.botoes.limpar'),
      cancelar: this.translate.instant('nova-transferencia.botoes.cancelar'),
      confirmar: this.translate.instant('nova-transferencia.botoes.confirmar'),
      filtrar: this.translate.instant('nova-transferencia.botoes.filtrar'),
      limpar_filtros: this.translate.instant('nova-transferencia.botoes.limpar_filtros')
    };

    this.tooltips = {
      editar: this.translate.instant('nova-transferencia.tooltips.editar'),
      excluir: this.translate.instant('nova-transferencia.tooltips.excluir')
    };
  }

  isColumnVisible(key: string): boolean {
    const col = this.columns.find(c => c.key === key);
    return col ? col.visible : true;
  }

  get visibleColumnCount(): number {
    return this.columns.filter(c => c.visible).length;
  }

  onColumnsChange(columns: TableColumn[]): void {
    this.columns = [...columns];
  }

  private loadColumnPreferences(): void {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const visibleKeys = JSON.parse(stored) as string[];
        this.columns.forEach(col => {
          if (!col.fixed) {
            col.visible = visibleKeys.includes(col.key);
          }
        });
      }
    } catch (e) {
      console.warn('Erro ao carregar preferências de colunas:', e);
    }
  }

  loadContas() {
    this.contaService.get('/conta').subscribe({
      next: (response) => {
        if (!response || !response.content) {
          return;
        }
        // Manter contasCarregadas COMPLETO (sem filtro) para preservar lookups
        // por id (moedaContaSelecionada, contasDestinoFiltradasOptions, edicao
        // de transferencia antiga com origem em moeda agora "ilegal").
        this.contasCarregadas = response.content;

        // Filtrar APENAS o dropdown ORIGEM por moedasPermitidas (regra de
        // pareamento da moeda padrao da empresa). Empresa PESO so ve contas
        // GUARANI/PESO; REAL/DOLAR ocultos (consistente com cards de Total e
        // demais telas: nova-despesa, nova-receita, /contas).
        // DESTINO continua filtrado em contasDestinoFiltradasOptions via
        // podeConverterEntre, que e mais fino. Saneamento de contas legacy
        // deve usar a tela /contas (gerenciar contas), nao a transferencia.
        const permitidas = this.moedasPermitidas;
        const contasVisiveis = response.content.filter((conta: ContaDTO) =>
          permitidas.has(this.asEnumString((conta as any).moeda)),
        );
        this.contasOptions = contasVisiveis.map((conta: ContaDTO) => {
          const moedaStr = this.asEnumString(conta.moeda);
          return {
            label: (conta.numeroConta as any) == 0 ? `${conta.tituloDaConta} - EFETIVO` : conta.tituloDaConta,
            value: conta.id!,
            moeda: moedaStr,
            flagUrl: this.getFlagUrl(conta.moeda),
            tipoConta: conta.tipoConta,
          };
        });

        // Ordenar: conta DINHEIRO da moeda padrao da empresa aparece primeiro
        if (this.empresa?.moeda && this.contasCarregadas) {
          const moedaPadrao = this.asEnumString(this.empresa.moeda);
          const contasRef = this.contasCarregadas;
          this.contasOptions.sort((a, b) => {
            const contaA = contasRef.find((c: any) => c.id === a.value);
            const contaB = contasRef.find((c: any) => c.id === b.value);
            const isTopA = contaA && this.asEnumString(contaA.tipoConta) === 'DINHEIRO' && this.asEnumString(contaA.moeda) === moedaPadrao ? 1 : 0;
            const isTopB = contaB && this.asEnumString(contaB.tipoConta) === 'DINHEIRO' && this.asEnumString(contaB.moeda) === moedaPadrao ? 1 : 0;
            return isTopB - isTopA;
          });
        }

        this.buildContasFiltroOptions();

        if (this.contasOptions.length > 0 && !this.form.id) {
          setTimeout(() => {
            this.form.conta_id = this.contasOptions[0].value;
            this.form.contaDestino_id = this.contasOptions[0].value;
            this.onContaOrigemChange();
            this.onContaDestinoChange();
            this.cdr.detectChanges();
          }, 100);
        }
        // A auto-selecao da conta DINHEIRO acontece dentro de
        // dispararCargaInicialSePronto() ANTES do primeiro loadTransferencias,
        // para que o primeiro load ja saia com conta=<id> (evita chamada duplicada).
        this._contasReady = true;
        this.dispararCargaInicialSePronto();
      },
      error: () => {
        // Mesmo em erro, liberar a carga inicial para nao travar a pagina.
        this._contasReady = true;
        this.dispararCargaInicialSePronto();
      }
    });
  }

  private buildContasFiltroOptions(): void {
    this.contasFiltroOptions = [
      ...this.contasOptions.map(c => ({ label: c.label, value: c.value, flagUrl: c.flagUrl }))
    ];

  }

  findEmpresa(): void {
    this.empresaService.getById('/configuracaoEmpresa/sessao').subscribe({
      next: (response) => {
        this.empresa = response;
        // Spec 08 — re-carregar cotacoes agora que sabemos a moeda padrao
        // real da empresa. O ngOnInit chamou loadCotacoes() antes da empresa
        // ter resolvido, retornando cotacao GUARANI por fallback (sem
        // pesoGuarani para empresa PESO). Recarregar com a moeda correta.
        this.loadCotacoes();
        // A auto-selecao de conta DINHEIRO e executada em dispararCargaInicialSePronto(),
        // depois que empresa e contas estiverem prontas. Evita chamadas duplicadas.
        this._empresaReady = true;
        this.dispararCargaInicialSePronto();
      },
      error: () => {
        // Mesmo em erro, liberar a carga inicial para nao travar a pagina.
        this._empresaReady = true;
        this.dispararCargaInicialSePronto();
      }
    });
  }

  /**
   * Auto-seleciona a conta tipo DINHEIRO da moeda padrao da empresa,
   * igualando o comportamento do mobile.
   */
  private autoSelecionarContaDinheiro(): void {
    if (this.filtroContaId != null) return;
    if (!this.contasCarregadas || this.contasCarregadas.length === 0) return;
    if (!this.empresa?.moeda) return;

    const moedaPadraoEnum = this.asEnumString(this.empresa.moeda);

    const contaDinheiro = this.contasCarregadas.find((c: any) => {
      const tipo = this.asEnumString(c.tipoConta);
      const moedaConta = this.asEnumString(c.moeda);
      return tipo === 'DINHEIRO' && moedaConta === moedaPadraoEnum;
    });

    if (contaDinheiro?.id) {
      // Flag anti-reentrada: o set programatico dispara (ngModelChange) do dropdown,
      // e o handler onFiltroCcontaChanged verifica esta flag para ignorar o evento.
      this._settingContaProgramatic = true;
      this.filtroContaId = contaDinheiro.id;
      this.filtroMoedaSelecionada = moedaPadraoEnum;
      this.filtrosAtivos = true;
      // O (ngModelChange) pode disparar de forma sincrona ou assincrona;
      // liberamos a flag na proxima volta do event loop para cobrir ambos os casos.
      setTimeout(() => { this._settingContaProgramatic = false; }, 0);

      // No fluxo atual coordenado (dispararCargaInicialSePronto), o filtro e setado
      // ANTES do primeiro load, entao este bloco so age se a empresa chegar depois
      // (caso raro). Mantido por seguranca.
      if (this._initialLoadDone) {
        this.loadTransferencias(0, this.rows);
        this.loadTotais();
      }
    }
  }

  /**
   * Coordena o PRIMEIRO loadTransferencias + loadTotais:
   * so dispara quando empresa e contas ja estao prontas.
   * Antes de disparar, aplica autoSelecionarContaDinheiro para que o
   * primeiro load ja saia com o filtro de conta correto (evitando reload duplicado).
   */
  private dispararCargaInicialSePronto(): void {
    if (!this._empresaReady || !this._contasReady) return;
    if (this._initialLoadDone) return;

    // Tentar auto-selecionar a conta DINHEIRO antes do primeiro load,
    // para que ele ja saia com o filtro correto (conta=<id>).
    this.autoSelecionarContaDinheiro();

    this._initialLoadDone = true;
    this.loadTransferencias(0, this.rows);
    this.loadTotais();
  }

  async loadCotacoes(): Promise<void> {
    const cotacao = await this.buscarUltimaCotacaoPorMoeda(this.getEmpresaMoedaPadrao());
    this.cotacao_id = cotacao?.id ?? 0;
    this.cotUSD_PYG = cotacao?.dolarGuarani;
    this.cotUSD_BRL = cotacao?.dolarReal;
    this.cotBRL_PYG = cotacao?.realGuarani;
    this.cotPesoGuarani = cotacao?.pesoGuarani;
  }

  validaMoedasDasContas(): boolean {
    const moedaOrigem = this.form.moedaDeOrigem?.value;
    const moedaDestino = this.form.moedaDeDestino?.value;
    if (!moedaOrigem || !moedaDestino) return true;
    return moedaOrigem === moedaDestino;
  }

  // Monta os parametros de filtro para as chamadas de listagem e totais
  private buildFiltroParams(page?: number, size?: number): { [key: string]: string | number } {
    const params: { [key: string]: string | number } = {};

    // Data inicio e fim dos filtros dedicados
    if (this.filtroDataInicio) {
      params['dataInicio'] = this.formatarDataHoraApiMovimento(this.filtroDataInicio, true);
    }
    if (this.filtroDataFim) {
      params['dataFim'] = this.formatarDataHoraApiMovimento(this.filtroDataFim, false);
    }

    if (page !== undefined) params['page'] = page;
    if (size !== undefined) params['size'] = size;

    // Ordenacao server-side (Spring Pageable)
    params['sort'] = `${this.lastfield},${this.lastSort}`;

    // Filtro por observacao (campo dedicado OU busca rapida)
    const observacaoFiltro = this.filtroObservacao?.trim() || this.searchTerm?.trim() || '';
    if (observacaoFiltro.length > 0) {
      params['observacao'] = observacaoFiltro;
    }

    if (this.filtroContaId) {
      params['conta'] = this.filtroContaId;
    }

    if (this.filtroMoeda) {
      params['moeda'] = this.filtroMoeda;
    }

    return params;
  }

  /**
   * Formata data no padrao que o backend espera: dd/MM/yyyy
   * Conforme API_CONTRACT_filtro_moeda_transferencia.md
   */
  private formatarDataHoraApiMovimento(date: Date, ehInicio: boolean): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const horas = ehInicio ? '00:00' : '23:59';
    return `${day}/${month}/${year}T${horas}`;
  }

  loadTransferencias(page: number, size: number) {
    this.loading = true;

    const params = this.buildFiltroParams(page, size);

    this.transferenciaService.listarComFiltros(params).subscribe({
      next: (response: any) => {
        if (response && response.content) {
          this.transferenciasOriginal = response.content;
          this.transferencias = [...this.transferenciasOriginal];
          this.totalRecords = response.totalElements || response.content.length;
        } else {
          this.transferenciasOriginal = [];
          this.transferencias = [];
          this.totalRecords = 0;
        }

        // Aplicar filtros locais se existirem (moeda ou busca textual)
        if ((this.searchTerm && this.searchTerm.trim().length > 0) || this.filtroMoedaSelecionada) {
          this.aplicarFiltrosLocais();
        }

        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  loadTotais(): void {
    this.loadingTotais = true;
    const params = this.buildFiltroParams();

    this.transferenciaService.getTotais(params).subscribe({
      next: (response: any) => {
        this.totalGuarani = response?.valorTotalEmGuarani || 0;
        this.totalDolar = response?.valorTotalEmDolar || 0;
        this.totalReal = response?.valorTotalEmReal || 0;
        this.totalPeso = response?.valorTotalEmPeso || 0;
        this.loadingTotais = false;
      },
      error: () => {
        this.totalGuarani = 0;
        this.totalDolar = 0;
        this.totalReal = 0;
        this.totalPeso = 0;
        this.loadingTotais = false;
      },
    });
  }

  private setupSearchDebounce() {
    this.search$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.first = 0;
      this.recarregarDados();
    });
  }

  // Aplicar filtros dedicados (padrao nova-despesa)
  aplicarFiltros(): void {
    this.filtrosAtivos = true;
    this.first = 0;
    this.recarregarDados();
  }

  /** Limpa filtros avançados do sidebar e reseta para período padrão (mês atual).
   *  Nota: filtroContaId, filtroMoeda e filtroMoedaSelecionada pertencem ao header inline,
   *  não ao sidebar de filtros avançados, por isso não são limpos aqui. */
  limparFiltros(): void {
    this.filtroObservacao = '';
    this.searchTerm = '';
    this.first = 0;

    // Manter periodo padrao (mes atual) como o mobile faz,
    // em vez de remover datas e trocar de endpoint
    const hoje = new Date();
    this.filtroDataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1, 0, 0, 0);
    this.filtroDataFim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59);
    this.filtrosAtivos = true;

    this.recarregarDados();
    this.loadTotais();
  }

  /** Filtra a tabela pela moeda clicada no card de totais.
   *  Clicar novamente no mesmo card remove o filtro (sem toggle).
   *  Seleciona automaticamente a conta DINHEIRO da moeda clicada e faz nova busca na API. */
  filtrarPorMoeda(moeda: string): void {
    // Bloquear clique quando conta bancaria esta ativa
    if (this.contaBancariaAtiva) {
      return;
    }
    // Se ja esta selecionada, manter o filtro (sem toggle)
    if (this.filtroMoedaSelecionada === moeda) {
      return;
    }

    // Selecionar a conta DINHEIRO da moeda clicada e fazer nova busca na API
    const contaDinheiroMoeda = this.contasCarregadas?.find((c: any) => {
      const tipo = this.asEnumString(c.tipoConta);
      const moedaConta = this.asEnumString(c.moeda);
      return tipo === 'DINHEIRO' && moedaConta === moeda.toUpperCase();
    });

    if (contaDinheiroMoeda) {
      this.filtroContaId = contaDinheiroMoeda.id!;
      this.filtroMoedaSelecionada = moeda;
      this.aplicarFiltros();
    } else {
      // Fallback: filtro local se nao encontrar conta DINHEIRO
      this.filtroMoedaSelecionada = moeda;
      this.aplicarFiltrosLocais();
    }
  }

  /** Aplica filtros locais (busca textual + moeda) sobre transferenciasOriginal */
  private aplicarFiltrosLocais(): void {
    let resultado = [...this.transferenciasOriginal];

    // Filtro por moeda — compara com moeda de origem E destino,
    // pois transferencias recebidas tem moedaDeOrigem diferente da conta filtrada
    if (this.filtroMoedaSelecionada) {
      const moedaFiltro = this.filtroMoedaSelecionada.toUpperCase();
      resultado = resultado.filter(t => {
        const moedaOrigem = this.asEnumString(t.moedaDeOrigem).toUpperCase();
        const moedaDestino = this.asEnumString(t.moedaDeDestino).toUpperCase();
        return moedaOrigem === moedaFiltro || moedaDestino === moedaFiltro;
      });
    }

    // Filtro por busca textual
    if (this.searchTerm && this.searchTerm.trim().length > 0) {
      const termLower = this.searchTerm.trim().toLowerCase();
      resultado = resultado.filter(t => this.matchTransferenciaSearch(t, termLower));
    }

    this.transferencias = resultado;
  }

  /** Verifica se uma transferencia corresponde ao termo de busca */
  private matchTransferenciaSearch(transferencia: any, termLower: string): boolean {
    if (this.isColumnVisible('id') && transferencia.id != null) {
      if (String(transferencia.id).includes(termLower)) return true;
    }
    if (this.isColumnVisible('emissao') && transferencia.emissao) {
      const dataFormatada = new Date(transferencia.emissao as any).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
      if (dataFormatada.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('observacao') && transferencia.observacao) {
      if (transferencia.observacao.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('valor') && transferencia.valor != null) {
      const valorFormatado = this.formatarValorMonetario(transferencia.valor, transferencia.moedaDeOrigem);
      if (valorFormatado.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('contaOrigem') && transferencia.contaOrigem?.descricao) {
      if (transferencia.contaOrigem.descricao.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('contaDestino') && transferencia.contaDestino?.descricao) {
      if (transferencia.contaDestino.descricao.toLowerCase().includes(termLower)) return true;
    }
    return false;
  }

  /** Recebe o periodo selecionado pelo componente periodo-filtro e converte para Date.
   *  Dispara a busca automaticamente ao alterar o periodo. */
  onPeriodoTransferenciaChanged(periodo: PeriodoFiltro): void {
    this.periodoTransferenciaTexto = periodo.texto;
    this.filtroDataInicio = this.parsarDataDashboard(periodo.dataInicio);
    this.filtroDataFim = this.parsarDataDashboard(periodo.dataFim);
    this.first = 0;
    // Guard anti-reentrada: o app-periodo-filtro dispara (periodoChanged) no
    // bootstrap com o valor padrao "thisMonth", gerando chamada duplicada.
    // O primeiro load coordenado em dispararCargaInicialSePronto ja consumira
    // esses mesmos filtros; ignoramos aqui ate ele ocorrer.
    if (!this._initialLoadDone) return;
    this.recarregarDados();
  }

  /** Dispara a busca automaticamente ao alterar o filtro de conta. */
  onFiltroCcontaChanged(): void {
    // Guard anti-reentrada: durante o bootstrap, a auto-selecao de conta DINHEIRO
    // faz um set programatico em filtroContaId que dispara este (ngModelChange).
    // Esse evento ja sera consumido pelo primeiro load coordenado em
    // dispararCargaInicialSePronto(); ignoramos aqui para evitar chamada duplicada.
    if (this._settingContaProgramatic) return;
    // Tambem ignoramos enquanto o primeiro load coordenado ainda nao ocorreu.
    if (!this._initialLoadDone) return;

    this.first = 0;
    // Atualizar filtroMoedaSelecionada para refletir a moeda da conta recém-selecionada.
    // moedaContaSelecionada já retorna null quando filtroContaId é null,
    // e retorna o enum correto tanto para contas DINHEIRO/EFETIVO quanto para contas BANCO.
    this.filtroMoedaSelecionada = this.moedaContaSelecionada;
    this.recarregarDados();
  }

  /**
   * Converte string no formato dd/MM/yyyy ou dd/MM/yyyyTHH:mm para Date.
   * Mesmo metodo utilizado em nova-despesa e nova-receita.
   */
  private parsarDataDashboard(valor: string): Date | null {
    try {
      // Suporta tanto dd/MM/yyyy quanto dd/MM/yyyyTHH:mm
      const [datePart, timePart] = valor.split('T');
      if (!datePart) return null;
      const [dia, mes, ano] = datePart.split('/').map(Number);
      const [hora, minuto] = (timePart || '00:00').split(':').map(Number);
      const d = new Date(ano, mes - 1, dia, hora || 0, minuto || 0);
      return isNaN(d.getTime()) ? null : d;
    } catch {
      return null;
    }
  }

  private recarregarDados(): void {
    this.loadTransferencias(0, this.rows);
    this.loadTotais();
  }

  onContaOrigemChange() {
    const conta = this.contasCarregadas?.find(conta => conta.id === this.form.conta_id);

    if (conta && conta.moeda) {
      this.form.moedaDeOrigem = {
        label: this.asEnumString(conta.moeda),
        value: this.asMoedaEnum(conta.moeda)
      };
    }

    // Se a conta destino atual deixou de ser compativel (ou virou igual a origem),
    // limpar para evitar enviar um par invalido ao backend.
    if (this.form.contaDestino_id != null) {
      const destinoAindaValido = this.contasDestinoFiltradasOptions
        .some(opt => opt.value === this.form.contaDestino_id);
      if (!destinoAindaValido) {
        this.form.contaDestino_id = null;
        this.form.moedaDeDestino = undefined;
      }
    }

    this.calcularValorConvertido();
    this.calcularCotacaoCalculada();
  }

  onContaDestinoChange() {
    const conta = this.contasCarregadas?.find(conta => conta.id === this.form.contaDestino_id);

    if (conta && conta.moeda) {
      this.form.moedaDeDestino = {
        label: this.asEnumString(conta.moeda),
        value: this.asMoedaEnum(conta.moeda)
      };
    }
    this.calcularValorConvertido();
    this.calcularCotacaoCalculada();
  }

  async submit() {
    if (this.submitting) return;
    this.isFormSubmitted = true;

    // Validacao: conta origem e destino nao podem ser iguais
    if (this.form.conta_id && this.form.conta_id === this.form.contaDestino_id) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('nova-transferencia.mensagens.mesma_conta'),
      });
      this.isFormSubmitted = false;
      return;
    }

    // Garante a cotacao do dia ANTES de validar tolerancia/finalizar (solicita se nao houver).
    const cotacaoDia = await this.cotacaoGuard.garantirCotacao({ moeda: this.getEmpresaMoedaPadrao() });
    if (!cotacaoDia) {
      this.isFormSubmitted = false;
      return;
    }
    await this.loadCotacoes();

    // Validacao de tolerancia de cotacao (quando moedas diferentes)
    if (!this.validaMoedasDasContas()) {
      const toleranciaOk = this.validarTolerancia();
      if (!toleranciaOk) {
        this.cotacaoDialogVisible = true;
        return;
      }
    }

    this.executarSubmit();
  }

  confirmarSubmitComCotacao(): void {
    this.cotacaoDialogVisible = false;
    this.executarSubmit();
  }

  private async executarSubmit() {
    // Rede de seguranca: cotacao de hoje valida (nunca id generico).
    const cotacaoDia = await this.cotacaoGuard.garantirCotacao({ moeda: this.getEmpresaMoedaPadrao() });
    if (!cotacaoDia?.id) {
      return;
    }
    this.cotacao_id = cotacaoDia.id;
    await this.montaMovimento();

    const isEdicao = !!this.form.id;

    const observable = isEdicao
      ? this.transferenciaService.put(`/movimento/${this.form.id}`, this.movimento)
      : this.transferenciaService.post('/movimento', this.movimento);

    this.submitting = true;
    observable.subscribe({
      next: () => {
        this.submitting = false;
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant(
            isEdicao
              ? 'nova-transferencia.mensagens.atualizada_sucesso'
              : 'nova-transferencia.mensagens.criada_sucesso'
          ),
        });
        this.isFormSubmitted = false;
        this.form = this.createEmptyForm();
        this.montanteStr = '';
        this.cotacaoCalculada = 0;
        this.dataSelecionada = 'hoje';
        this.outrosLabel = this.labels.outros;
        this.definirDataHoje();
        this.loadTranslations();
        this.recarregarDados();
        this.loadContas();
        // Trocar para aba de lista
        this.activeTabIndex = 1;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.submitting = false;
        // Mapeia chaves de erro do backend (ex.: conversao_nao_permitida_entre_moedas,
        // transferencia_peso_apenas_guarani) para mensagens amigaveis traduzidas.
        const codigo: string | undefined = err?.error?.code;
        const mensagemBackend: string | undefined = err?.error?.message;
        const chaveI18n = codigo ? `erros.${codigo}` : '';
        const traduzida = chaveI18n ? this.translate.instant(chaveI18n) : '';
        const detalhe = (traduzida && traduzida !== chaveI18n)
          ? traduzida
          : (mensagemBackend || this.translate.instant('common.erro_inesperado'));
        const severidade: 'error' | 'warn' = err?.status === 422 ? 'warn' : 'error';
        this.messageService.add({
          severity: severidade,
          summary: this.translate.instant('common.erro'),
          detail: detalhe,
        });
      },
    });
  }

  async montaMovimento() {
    this.movimento = {
      id: this.form.id || null,
      codigoMovimento: null,
      observacao: this.form.descricao?.trim() || null,
      tipoDeTransacao: "TRANSFERENCIA",
      cancelado: false,
      valor: this.form.valor!,
      cotacaoId: this.cotacao_id,
      contaId: this.form.conta_id,
      contaDestinoId: this.form.contaDestino_id,
      pessoaId: this.form.pessoa_id ?? null,
      moedaDeOrigem: this.asEnumString(this.form.moedaDeOrigem?.value),
      moedaDeDestino: this.asEnumString(this.form.moedaDeDestino?.value),
      cotacaoDeTransferencia: this.form.cotacaoDeTransferencia,
      valorConvertido: this.form.valorConvertido!,
      valorRecebidoNaConta: this.form.valor!,
      valorRecebidoEmGuarani: 0,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      // Spec 08 — payload de transferencia inclui valorRecebidoEmPeso para
      // pares envolvendo ARS (backend persiste em Movimento.valorRecebidoEmPeso
      // e gera baixa quando > 0). Mantido 0 como os demais; backend calcula
      // com base nas moedas de origem/destino + valor + cotacao.
      valorRecebidoEmPeso: 0,
      valorTotalMoedaPadrao: this.form.valor!,
      emissao: toLocalISOString(this.form.emissao instanceof Date ? this.form.emissao : new Date()),
      baixas: [],
    };
  }

  // Validacao de tolerancia de cotacao (identica ao mobile)
  private validarTolerancia(): boolean {
    if (this.cotacaoCalculada <= 0) return true;

    const moedaOrigem = this.form.moedaDeOrigem?.value;
    const moedaDestino = this.form.moedaDeDestino?.value;
    const cotacaoDoDia = this.form.cotacaoDeTransferencia || 0;

    if (cotacaoDoDia <= 0) return true;

    const diferenca = Math.abs(this.cotacaoCalculada - cotacaoDoDia);

    // Dolar <-> Real: tolerancia +-0.2
    if ((moedaOrigem === Moeda.DOLAR && moedaDestino === Moeda.REAL) ||
        (moedaOrigem === Moeda.REAL && moedaDestino === Moeda.DOLAR)) {
      return diferenca <= 0.2;
    }

    // Dolar <-> Guarani: tolerancia +-300
    if ((moedaOrigem === Moeda.DOLAR && moedaDestino === Moeda.GUARANI) ||
        (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.DOLAR)) {
      return diferenca <= 300;
    }

    // Real <-> Guarani: tolerancia +-200
    if ((moedaOrigem === Moeda.REAL && moedaDestino === Moeda.GUARANI) ||
        (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.REAL)) {
      return diferenca <= 200;
    }

    // Spec 08 — Peso <-> Guarani: tolerancia +-0.5 (cotacao tipica ~5 PYG/ARS,
    // ordem de grandeza similar a USD<->BRL que usa +-0.2)
    if ((moedaOrigem === Moeda.PESO && moedaDestino === Moeda.GUARANI) ||
        (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.PESO)) {
      return diferenca <= 0.5;
    }

    return true;
  }

  // Calculo de cotacao calculada (identico ao mobile: novovalorCotacaoCalculada)
  calcularCotacaoCalculada(): void {
    const valor = this.form.valor || 0;
    const valorConvertido = this.form.valorConvertido || 0;

    if (valor <= 0 || valorConvertido <= 0) {
      this.cotacaoCalculada = 0;
      return;
    }

    const moedaOrigem = this.form.moedaDeOrigem?.value;
    const moedaDestino = this.form.moedaDeDestino?.value;

    if (moedaOrigem === moedaDestino) {
      this.cotacaoCalculada = 1;
      return;
    }

    // Logica identica ao mobile
    if (moedaOrigem === Moeda.DOLAR) {
      // Dolar -> qualquer: cotacao = valorConvertido / valor
      this.cotacaoCalculada = valorConvertido / valor;
    } else if (moedaOrigem === Moeda.GUARANI) {
      // Guarani -> qualquer: cotacao = valor / valorConvertido
      this.cotacaoCalculada = valor / valorConvertido;
    } else if (moedaOrigem === Moeda.REAL && moedaDestino === Moeda.GUARANI) {
      // Real -> Guarani: cotacao = valorConvertido / valor
      this.cotacaoCalculada = valorConvertido / valor;
    } else if (moedaOrigem === Moeda.REAL && moedaDestino === Moeda.DOLAR) {
      // Real -> Dolar: cotacao = valor / valorConvertido
      this.cotacaoCalculada = valor / valorConvertido;
    } else if (moedaOrigem === Moeda.PESO && moedaDestino === Moeda.GUARANI) {
      // Spec 08 — Peso -> Guarani: cotacao = valorConvertido / valor (replica padrao Real->Guarani)
      this.cotacaoCalculada = valorConvertido / valor;
    } else {
      this.cotacaoCalculada = 0;
    }
  }

  get cotacaoCalculadaDisplay(): string {
    if (this.cotacaoCalculada <= 0) return '-';
    return this.cotacaoCalculada.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    });
  }

  async buscarUltimaCotacaoPorMoeda(moeda: Moeda): Promise<any> {
    try {
      const cotacao = await firstValueFrom(this.cotacaoService.get(`/cotacao/ultimaCotacao?moedaPadrao=${moeda}`));
      return cotacao;
    } catch (error: any) {
      // Sem cotacao: o fluxo de envio solicita via CotacaoGuardService.
      return null;
    }
  }

  private getEmpresaMoedaPadrao(): Moeda {
    // Spec 08 — usar a moeda padrao real da empresa para que a cotacao
    // certa seja buscada (ex: empresa PESO cadastra cotacao com moedaPadrao=PESO,
    // que e a unica que retorna pesoGuarani). Hardcoded GUARANI quebrava
    // empresa PESO (cotPesoGuarani ficava nulo => calculo de conversao zerado).
    const moedaEmp = this.empresa?.moeda;
    if (!moedaEmp) return Moeda.GUARANI;
    return this.asMoedaEnum(moedaEmp);
  }

  private asMoedaEnum(value: any): Moeda {
    if (!value) return Moeda.REAL;
    const stringValue = this.asEnumString(value).toUpperCase();
    switch (stringValue) {
      case 'GUARANI':
        return Moeda.GUARANI;
      case 'REAL':
        return Moeda.REAL;
      case 'DOLAR':
        return Moeda.DOLAR;
      case 'PESO':
        return Moeda.PESO;
      default:
        return Moeda.REAL;
    }
  }

  onRowsPerPageChange() {
    // Guard anti-reentrada: enquanto o primeiro load coordenado nao ocorreu,
    // ignorar qualquer (ngModelChange) do dropdown (dispara no bootstrap).
    if (!this._initialLoadDone) return;
    this.first = 0;
    this.loadTransferencias(0, this.rows);
  }

  onPageChange(event: any) {
    // Guard anti-reentrada: o p-paginator dispara (onPageChange) no bootstrap,
    // antes do primeiro load coordenado acontecer em dispararCargaInicialSePronto.
    if (!this._initialLoadDone) return;
    this.first = event.first;
    this.rows = event.rows;
    const page = event.page;
    const size = event.rows;
    this.loadTransferencias(page, size);
  }

  /**
   * Para transferencias entre moedas, o campo 'valor' ja vem convertido para a conta filtrada,
   * mas 'moedaDeOrigem' reflete a moeda da conta de origem (ex: DOLAR).
   * Este metodo retorna a moeda correta baseada na conta selecionada no filtro.
   */
  resolverMoedaTransferencia(t: any): any {
    const moedaConta = this.moedaContaSelecionada?.toUpperCase();
    if (!moedaConta) return t.moedaDeOrigem;
    // Se a moedaDeDestino corresponde a conta selecionada, usar ela
    const moedaDestino = this.asEnumString(t.moedaDeDestino).toUpperCase();
    if (moedaDestino === moedaConta) return t.moedaDeDestino;
    // Senao, usar moedaDeOrigem (a conta selecionada e a de origem)
    return t.moedaDeOrigem;
  }

  private asEnumString(v: any): string {
    if (!v) return '';

    if (typeof v === 'object' && 'enum' in v) {
      return String(v.enum).toUpperCase();
    }

    if (typeof v === 'string') {
      return v.toUpperCase();
    }

    if (typeof v === 'object' && 'value' in v) {
      return String(v.value).toUpperCase();
    }

    return String(v ?? '').toUpperCase();
  }

  editarTransferencia(transferencia: any) {
    // Se veio da listagem (sem campo contaOrigem detalhado), buscar dados completos via /movimento/{id}.
    // Nao usar cotacaoDeTransferencia como criterio pois pode ser 0 em transferencias da mesma moeda.
    const precisaBuscarDetalhes = transferencia.id &&
      transferencia.cotacaoDeTransferencia == null &&
      !transferencia.contaDTO &&
      !transferencia.contaDestinoDTO;

    if (precisaBuscarDetalhes) {
      this.transferenciaService.getById(`/movimento/${transferencia.id}`).subscribe({
        next: (completa: TransferenciaDTO) => {
          this._popularFormularioEdicao(completa);
        },
        error: () => {
          // Fallback: usar dados da listagem mesmo incompletos
          this._popularFormularioEdicao(transferencia);
        },
      });
      return;
    }
    this._popularFormularioEdicao(transferencia);
  }

  private _popularFormularioEdicao(transferencia: any) {
    this.dataSelecionada = 'outros';

    const dataEmissao = transferencia.emissao ? new Date(transferencia.emissao) : new Date();

    // O endpoint de listagem retorna contaOrigem e contaDestino (com id e descricao).
    // O endpoint de detalhe retorna contaDTO e contaDestinoDTO.
    // Tratar ambos os formatos para garantir compatibilidade.
    const contaOrigemId =
      transferencia.contaOrigem?.id ||
      transferencia.contaDTO?.id ||
      transferencia.conta_id ||
      null;

    const contaDestinoId =
      transferencia.contaDestino?.id ||
      transferencia.contaDestinoDTO?.id ||
      transferencia.contaDestino_id ||
      null;

    this.form = {
      id: transferencia.id,
      observacao: transferencia.observacao || '',
      tipoDeTransacao: transferencia.tipoDeTransacao || TipoTransacao.TRANSFERENCIA,
      cancelado: transferencia.cancelado || false,
      valor: transferencia.valor || 0,
      cotacao_id: transferencia.cotacao_id || 0,
      conta_id: contaOrigemId,
      contaDestino_id: contaDestinoId,
      moedaDeOrigem: transferencia.moedaDeOrigem ? {
        label: this.asEnumString(transferencia.moedaDeOrigem),
        value: this.asMoedaEnum(transferencia.moedaDeOrigem)
      } : undefined,
      moedaDeDestino: transferencia.moedaDeDestino ? {
        label: this.asEnumString(transferencia.moedaDeDestino),
        value: this.asMoedaEnum(transferencia.moedaDeDestino)
      } : undefined,
      cotacaoDeTransferencia: transferencia.cotacaoDeTransferencia || 0,
      valorConvertido: transferencia.valorConvertido || 0,
      emissao: dataEmissao,
      pessoa_id: transferencia.pessoa_id || null,
      baixas: transferencia.baixas || [],
      valorRecebidoNaConta: transferencia.valorRecebidoNaConta || 0,
      valorRecebidoEmGuarani: transferencia.valorRecebidoEmGuarani || 0,
      valorRecebidoEmDolar: transferencia.valorRecebidoEmDolar || 0,
      valorRecebidoEmReal: transferencia.valorRecebidoEmReal || 0,
      // Spec 08 — preservar valorRecebidoEmPeso na edicao (backend retorna o campo)
      valorRecebidoEmPeso: transferencia.valorRecebidoEmPeso || 0,
      descricao: transferencia.observacao || transferencia.descricao || ''
    };

    // Popular string formatada do campo de valor para exibicao correta no input
    this.montanteStr = this.formatarMontanteParaExibicao(
      transferencia.valor ?? 0,
      this.form.moedaDeOrigem?.value
    );

    // Trocar para aba de cadastro com os dados preenchidos
    this.activeTabIndex = 0;

    this.loadTranslations();
    this.calcularCotacaoCalculada();

    // Aguardar as contas estarem carregadas antes de atualizar moedas derivadas.
    // Nao sobreescrever moedaDeOrigem/moedaDeDestino caso ja tenham sido preenchidas
    // a partir dos dados da transferencia — apenas recalcular valor convertido.
    setTimeout(() => {
      if (!this.form.moedaDeOrigem && this.form.conta_id) {
        this.onContaOrigemChange();
      }
      if (!this.form.moedaDeDestino && this.form.contaDestino_id) {
        this.onContaDestinoChange();
      }

      // Setar cotacaoDeTransferencia a partir das cotacoes carregadas,
      // pois o DTO de listagem nao retorna esse campo
      if (!this.form.cotacaoDeTransferencia) {
        this.setCotacaoDeTransferenciaPorMoedas();
        this.calcularValorConvertido();
      }

      // Popular o input de valor convertido (que usa input.value, nao ngModel)
      this.atualizarInputValorConvertido();

      this.cdr.detectChanges();
    }, 200);
  }

  /**
   * Carrega uma transferencia pelo ID do movimento para edicao.
   * Chamado quando a tela recebe queryParam editId (navegacao da lista de movimentos).
   * Usa _popularFormularioEdicao diretamente para evitar loop na verificacao de cotacaoDeTransferencia.
   */
  private carregarTransferenciaParaEdicao(movimentoId: number): void {
    this.transferenciaService.getById(`/movimento/${movimentoId}`).subscribe({
      next: (transferencia: TransferenciaDTO) => {
        this._popularFormularioEdicao(transferencia);
      },
      error: (err) => {
        console.error('Erro ao carregar transferencia para edicao:', err);
      },
    });
  }

  deletarTransferencia(id: number) {
    this.deleteItemId = id;
    this.deleteDialogVisible = true;
  }

  confirmarExclusao(): void {
    if (!this.deleteItemId) return;

    this.transferenciaService.delete(`/movimento/${this.deleteItemId}`).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant('nova-transferencia.mensagens.excluida_sucesso'),
        });
        this.deleteDialogVisible = false;
        this.deleteItemId = null;
        this.recarregarDados();
      },
      error: () => {
        this.deleteDialogVisible = false;
        this.deleteItemId = null;
      },
    });
  }

  private createEmptyForm(): TransferenciaDTO {
    return {
      observacao: '',
      descricao: '',
      tipoDeTransacao: TipoTransacao.TRANSFERENCIA,
      cancelado: false,
      valor: 0,
      cotacao_id: 0,
      conta_id: null,
      pessoa_id: null,
      moedaDeOrigem: undefined,
      contaDestino_id: null,
      moedaDeDestino: undefined,
      cotacaoDeTransferencia: 0,
      valorConvertido: 0,
      emissao: undefined,
      baixas: [],
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: 0,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      // Spec 08 — payload preparado para ARS (backend persiste em Movimento.valorRecebidoEmPeso)
      valorRecebidoEmPeso: 0,
    };
  }

  getDropItems(enumType: any): { label: string; value: any }[] {
    return Object.values(enumType).map((item) => ({
      label: String(item).toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      value: item,
    }));
  }

  getSelectedCurrencySymbol(contaId?: number | null): string {
    if (!contaId || !this.contasCarregadas) {
      return '';
    }

    const conta = this.contasCarregadas.find(c => c.id === contaId);

    if (!conta || !conta.moeda) {
      return '';
    }

    const moedaEnum = this.asMoedaEnum((conta as any).moeda);

    return this.getCurrencySymbol(moedaEnum);
  }

  getFlagUrl(moeda: any): string {
    const moedaStr = this.asEnumString(moeda);
    switch (moedaStr) {
      case 'GUARANI': return 'assets/images/paraguay-flag.jpg';
      case 'REAL': return 'assets/images/br-flag.svg';
      case 'DOLAR': return 'assets/images/usa-flag.svg';
      case 'PESO': return 'assets/images/argentina-flag.svg';
      default: return '';
    }
  }

  getCurrencyLabel(moeda: any): string {
    const moedaStr = this.asEnumString(moeda);
    switch (moedaStr) {
      case 'GUARANI': return this.translate.instant('nova-transferencia.moedas.guarani');
      case 'REAL': return this.translate.instant('nova-transferencia.moedas.real');
      case 'DOLAR': return this.translate.instant('nova-transferencia.moedas.dolar');
      case 'PESO': return this.translate.instant('nova-transferencia.moedas.peso');
      default: return '';
    }
  }

  /**
   * Monta o label da conta no dropdown.
   * Segue o mesmo padrao da tela de movimentacao (extrato de caixa):
   * numeroConta == 0 => "EFETIVO - {tituloDaConta}"
   * Caso contrario => tituloDaConta
   */
  private buildContaLabel(conta: ContaDTO): string {
    return (conta.numeroConta as any) == 0
      ? `EFETIVO - ${conta.tituloDaConta}`
      : conta.tituloDaConta;
  }

  getMoedaDaConta(contaId: number | null | undefined): Moeda | undefined {
    if (!contaId || !this.contasCarregadas) return undefined;
    const conta = this.contasCarregadas.find(c => c.id === contaId);
    return conta ? this.asMoedaEnum(conta.moeda) : undefined;
  }

  private getCurrencySymbol(moeda: Moeda): string {
    switch (moeda) {
      case Moeda.REAL:
        return 'R$ ';
      case Moeda.DOLAR:
        return '$ ';
      case Moeda.GUARANI:
        return 'Gs ';
      case Moeda.PESO:
        return '$ ';
      default:
        return '';
    }
  }

  formataCampoMontante(event: any, campo: 'valor' | 'valorConvertido' = 'valor'): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value || '';
    const onlyDigits = raw.replace(/\D+/g, '');
    const moeda = campo === 'valor' ? this.form.moedaDeOrigem?.value : this.form.moedaDeDestino?.value;

    if (!onlyDigits) {
      if (campo === 'valor') {
        this.form.valor = 0;
        this.montanteStr = '';
        this.calcularValorConvertido();
      } else {
        this.form.valorConvertido = 0;
      }
      this.calcularCotacaoCalculada();
      input.value = '';
      return;
    }

    if (moeda === Moeda.GUARANI) {
      // Guarani: sem centavos, apenas separador de milhar
      const intVal = parseInt(onlyDigits, 10);
      if (campo === 'valor') {
        this.form.valor = intVal || 0;
        this.calcularValorConvertido();
      } else {
        this.form.valorConvertido = intVal || 0;
        this.calcularCotacaoCalculada();
      }
      const formatted = intVal
        ? intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
      input.value = formatted;
      if (campo === 'valor') this.montanteStr = formatted;
    } else if (moeda === Moeda.DOLAR) {
      // Dolar: 2 casas decimais, formato 1,234.56
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      if (campo === 'valor') {
        this.form.valor = cents ? val : 0;
        this.calcularValorConvertido();
      } else {
        this.form.valorConvertido = cents ? val : 0;
        this.calcularCotacaoCalculada();
      }
      const formatted = cents
        ? val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      input.value = formatted;
      if (campo === 'valor') this.montanteStr = formatted;
    } else if (moeda === Moeda.PESO) {
      // Spec 08 — Peso: 2 casas decimais, locale es-AR (virgula decimal, formato 1.234,56)
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      if (campo === 'valor') {
        this.form.valor = cents ? val : 0;
        this.calcularValorConvertido();
      } else {
        this.form.valorConvertido = cents ? val : 0;
        this.calcularCotacaoCalculada();
      }
      const formatted = cents
        ? val.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      input.value = formatted;
      if (campo === 'valor') this.montanteStr = formatted;
    } else {
      // Real: 2 casas decimais, formato 1.234,56
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      if (campo === 'valor') {
        this.form.valor = cents ? val : 0;
        this.calcularValorConvertido();
      } else {
        this.form.valorConvertido = cents ? val : 0;
        this.calcularCotacaoCalculada();
      }
      const formatted = cents
        ? val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      input.value = formatted;
      if (campo === 'valor') this.montanteStr = formatted;
    }
  }

  selecionarData(tipo: string): void {
    this.dataSelecionada = tipo;

    const hoje = new Date();

    switch (tipo) {
      case 'hoje':
        this.form.emissao = new Date();
        // Resetar label do botao "Outros" para o texto original
        this.outrosLabel = this.labels.outros;
        break;
      case 'ontem':
        const ontem = new Date(hoje);
        ontem.setDate(hoje.getDate() - 1);
        this.form.emissao = ontem;
        // Resetar label do botao "Outros" para o texto original
        this.outrosLabel = this.labels.outros;
        break;
      case 'outros':
        if (!this.form.emissao) {
          this.form.emissao = new Date();
        }
        break;
    }

    if (this.form.emissao) {
      this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
    }
  }

  abrirCalendario(): void {
    this.dataSelecionada = 'outros';
    setTimeout(() => {
      if (this.calendario) {
        const inputEl = this.calendario.inputfieldViewChild?.nativeElement;
        if (inputEl) {
          // Temporariamente habilitar o input para receber foco
          inputEl.removeAttribute('tabindex');
          inputEl.style.pointerEvents = 'auto';
          inputEl.focus();
          inputEl.click();
          // Voltar a desabilitar apos abrir
          setTimeout(() => {
            inputEl.setAttribute('tabindex', '-1');
            inputEl.style.pointerEvents = 'none';
          }, 100);
        }
      }
    }, 0);
  }

  onDataSelecionada(): void {
    if (this.form.emissao) {
      this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
      // Atualizar label do botao "Outros" com a data selecionada
      this.outrosLabel = this.formatarDataParaExibicao(this.form.emissao);
    }
  }

  private definirDataHoje(): void {
    this.dataSelecionada = 'hoje';
    this.form.emissao = new Date();
    this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
  }

  // Preserva a data escolhida pelo usuario e usa a hora atual (igual ao
  // helper de nova-receita/nova-despesa). Antes esta funcao zerava a hora,
  // mas o `formatarEmissaoParaAPI` (removido pela spec 12) compensava isso
  // injetando `agora`. Agora que o submit usa `toLocalISOString` direto, a
  // composicao precisa acontecer aqui para manter o comportamento original.
  private formatarDataParaAPI(data: Date): Date {
    const d = data instanceof Date ? data : new Date(data);
    const agora = new Date();
    return new Date(
      d.getFullYear(), d.getMonth(), d.getDate(),
      agora.getHours(), agora.getMinutes(), agora.getSeconds()
    );
  }

  private formatarDataParaExibicao(data: Date): string {
    const d = new Date(data);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  onTabChange(event: { index: number }): void {
    // index 0 = Cadastro, index 1 = Lista
    if (event.index === 1) {
      this.texts.titulo = this.translate.instant('nova-transferencia.texts.titulo_nova');
      this.texts.subtitulo = this.translate.instant('nova-transferencia.texts.subtitulo_lista');
    } else {
      const isEdicao = !!this.form.id;
      this.texts.titulo = this.translate.instant(
        isEdicao ? 'nova-transferencia.texts.titulo_editar' : 'nova-transferencia.texts.titulo_nova'
      );
      this.texts.subtitulo = this.translate.instant(
        isEdicao ? 'nova-transferencia.texts.subtitulo_editar' : 'nova-transferencia.texts.subtitulo_nova'
      );
    }
  }

  limparFormulario() {
    this.isFormSubmitted = false;
    this.form = this.createEmptyForm();
    this.montanteStr = '';
    this.cotacaoCalculada = 0;
    this.dataSelecionada = 'hoje';
    this.outrosLabel = this.labels.outros;
    this.definirDataHoje();
    this.loadTranslations();
    this.loadContas();
    // Remover editId da URL
    this.router.navigate([], { relativeTo: this.route, queryParams: {} });
    // Voltar para aba de lista
    this.activeTabIndex = 1;
    this.cdr.detectChanges();
  }

  novaTransferencia(): void {
    this.isFormSubmitted = false;
    this.form = this.createEmptyForm();
    this.montanteStr = '';
    this.cotacaoCalculada = 0;
    this.dataSelecionada = 'hoje';
    this.outrosLabel = this.labels.outros;
    this.definirDataHoje();
    this.texts.titulo = this.translate.instant('nova-transferencia.texts.titulo_nova');
    this.texts.subtitulo = this.translate.instant('nova-transferencia.texts.subtitulo_nova');
    this.router.navigate([], { relativeTo: this.route, queryParams: {} });
    this.activeTabIndex = 0;
    this.cdr.detectChanges();
  }

  onSearchChange(value: string) {
    this.searchTerm = value || '';
    this.aplicarFiltrosLocais();
  }

  customSort(event: SortEvent): void {
    if (!event.field) return;
    const field = event.field;
    const novoSort = (event.order ?? 1) === 1 ? 'asc' : 'desc';

    // Guarda contra re-emissao: ignora se campo e direcao nao mudaram
    if (field === this.lastfield && novoSort === this.lastSort) {
      return;
    }

    // Atualiza parametros de ordenacao e dispara nova chamada a API
    // para que o sort seja aplicado sobre todos os registros, nao apenas a pagina corrente
    this.lastfield = field;
    this.lastSort = novoSort;
    this.first = 0; // volta para a primeira pagina ao reordenar
    this.loadTransferencias(0, this.rows);
  }

  calcularValorConvertido() {
    const valor = this.form.valor || 0;
    const moedaOrigem = this.form.moedaDeOrigem?.value;
    const moedaDestino = this.form.moedaDeDestino?.value;

    if (moedaOrigem === moedaDestino) {
      this.form.valorConvertido = valor;
      this.form.cotacaoDeTransferencia = 1;
      this.atualizarInputValorConvertido();
      return;
    }

    if (moedaOrigem === Moeda.DOLAR && moedaDestino === Moeda.GUARANI) {
      this.form.valorConvertido = valor * (this.cotUSD_PYG || 0);
      this.form.cotacaoDeTransferencia = this.cotUSD_PYG || 0;
    }
    else if (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.DOLAR) {
      this.form.valorConvertido = this.cotUSD_PYG ? valor / this.cotUSD_PYG : 0;
      this.form.cotacaoDeTransferencia = this.cotUSD_PYG ? 1 / this.cotUSD_PYG : 0;
    }
    else if (moedaOrigem === Moeda.REAL && moedaDestino === Moeda.GUARANI) {
      this.form.valorConvertido = valor * (this.cotBRL_PYG || 0);
      this.form.cotacaoDeTransferencia = this.cotBRL_PYG || 0;
    }
    else if (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.REAL) {
      this.form.valorConvertido = this.cotBRL_PYG ? valor / this.cotBRL_PYG : 0;
      this.form.cotacaoDeTransferencia = this.cotBRL_PYG ? 1 / this.cotBRL_PYG : 0;
    }
    else if (moedaOrigem === Moeda.DOLAR && moedaDestino === Moeda.REAL) {
      this.form.valorConvertido = valor * (this.cotUSD_BRL || 0);
      this.form.cotacaoDeTransferencia = this.cotUSD_BRL || 0;
    }
    else if (moedaOrigem === Moeda.REAL && moedaDestino === Moeda.DOLAR) {
      this.form.valorConvertido = this.cotUSD_BRL ? valor / this.cotUSD_BRL : 0;
      this.form.cotacaoDeTransferencia = this.cotUSD_BRL ? 1 / this.cotUSD_BRL : 0;
    }
    // Spec 08 — PESO<->GUARANI (replica padrao BRL<->PYG)
    else if (moedaOrigem === Moeda.PESO && moedaDestino === Moeda.GUARANI) {
      this.form.valorConvertido = valor * (this.cotPesoGuarani || 0);
      this.form.cotacaoDeTransferencia = this.cotPesoGuarani || 0;
    }
    else if (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.PESO) {
      this.form.valorConvertido = this.cotPesoGuarani ? valor / this.cotPesoGuarani : 0;
      this.form.cotacaoDeTransferencia = this.cotPesoGuarani ? 1 / this.cotPesoGuarani : 0;
    }
    else {
      this.form.valorConvertido = 0;
      this.form.cotacaoDeTransferencia = 0;
    }

    this.atualizarInputValorConvertido();
    // Fallback: se o *ngIf acabou de renderizar o campo, o ViewChild
    // ainda nao esta disponivel. Tentar novamente apos o render.
    if (!this.valorConvertidoInputRef?.nativeElement) {
      setTimeout(() => this.atualizarInputValorConvertido(), 0);
    }
    this.calcularCotacaoCalculada();
  }

  /**
   * Define cotacaoDeTransferencia com base nas moedas de origem/destino
   * usando as cotacoes ja carregadas. Usado na edicao, onde o DTO de
   * listagem nao retorna esse campo.
   */
  private setCotacaoDeTransferenciaPorMoedas(): void {
    const moedaOrigem = this.form.moedaDeOrigem?.value;
    const moedaDestino = this.form.moedaDeDestino?.value;

    if (moedaOrigem === moedaDestino) {
      this.form.cotacaoDeTransferencia = 1;
      return;
    }

    if ((moedaOrigem === Moeda.DOLAR && moedaDestino === Moeda.GUARANI) ||
        (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.DOLAR)) {
      this.form.cotacaoDeTransferencia = this.cotUSD_PYG || 0;
    } else if ((moedaOrigem === Moeda.REAL && moedaDestino === Moeda.GUARANI) ||
               (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.REAL)) {
      this.form.cotacaoDeTransferencia = this.cotBRL_PYG || 0;
    } else if ((moedaOrigem === Moeda.DOLAR && moedaDestino === Moeda.REAL) ||
               (moedaOrigem === Moeda.REAL && moedaDestino === Moeda.DOLAR)) {
      this.form.cotacaoDeTransferencia = this.cotUSD_BRL || 0;
    } else if ((moedaOrigem === Moeda.PESO && moedaDestino === Moeda.GUARANI) ||
               (moedaOrigem === Moeda.GUARANI && moedaDestino === Moeda.PESO)) {
      // Spec 08 — PESO<->GUARANI usa pesoGuarani (replica padrao BRL<->PYG)
      this.form.cotacaoDeTransferencia = this.cotPesoGuarani || 0;
    }
  }

  /**
   * Atualiza o valor exibido no input de "Valor Convertido" com o resultado
   * calculado automaticamente pela cotacao do dia.
   * Formata conforme a moeda de destino (Guarani sem decimais, Real/Dolar com 2 decimais).
   */
  private atualizarInputValorConvertido(): void {
    const input = this.valorConvertidoInputRef?.nativeElement;
    if (!input) return;

    const valorConvertido = this.form.valorConvertido || 0;
    const moedaDestino = this.form.moedaDeDestino?.value;

    if (valorConvertido <= 0) {
      input.value = '';
      return;
    }

    if (moedaDestino === Moeda.GUARANI) {
      const intVal = Math.round(valorConvertido);
      input.value = intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else if (moedaDestino === Moeda.DOLAR) {
      input.value = valorConvertido.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else if (moedaDestino === Moeda.PESO) {
      // Spec 08 — Peso usa locale es-AR (virgula decimal)
      input.value = valorConvertido.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
      // Real (padrao)
      input.value = valorConvertido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }

  formatarValorMonetario(valor: number, moedaDeOrigem: any): string {
    if (valor == null || isNaN(valor)) return '-';

    const moedaStr = this.asEnumString(moedaDeOrigem).toUpperCase();

    const configuracoes: Record<string, { locale: string; simbolo: string; decimais: boolean }> = {
      'GUARANI': { locale: 'es-PY', simbolo: 'Gs', decimais: false },
      'REAL': { locale: 'pt-BR', simbolo: 'R$', decimais: true },
      'DOLAR': { locale: 'en-US', simbolo: '$', decimais: true },
      'PESO': { locale: 'es-AR', simbolo: '$', decimais: true },
    };

    const config = configuracoes[moedaStr] ?? configuracoes['GUARANI'];
    const options: Intl.NumberFormatOptions = config.decimais
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 };

    const valorFormatado = new Intl.NumberFormat(config.locale, options).format(valor);
    return `${config.simbolo} ${valorFormatado}`;
  }

  /**
   * Formata um valor numerico para exibicao no input de montante (sem simbolo de moeda).
   * Usado ao editar uma transferencia para popular o campo de valor corretamente.
   * (padrao nova-despesa)
   */
  private formatarMontanteParaExibicao(valor: number, moeda: Moeda | undefined): string {
    if (valor == null || isNaN(valor) || valor <= 0) return '';

    if (moeda === Moeda.GUARANI) {
      const intVal = Math.round(valor);
      return intVal
        ? intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
    } else if (moeda === Moeda.DOLAR) {
      return valor
        ? valor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    } else if (moeda === Moeda.PESO) {
      // Spec 08 — Peso usa locale es-AR (virgula decimal, ponto milhar)
      return valor
        ? valor.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    } else {
      return valor
        ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    }
  }
}
